import WebsiteRedirectFsnPage from '@/components/websites/WebsiteRedirectFsnPage'
import { createFileRoute } from '@tanstack/react-router'
import { loadWebsiteRedirectsRoute } from './-loader'

export const flowerShopNetworkRedirectsLoader = (args) =>
  loadWebsiteRedirectsRoute({ ...args, requireFsnEnabled: true })

export const Route = createFileRoute(
  '/_authenticated/$orgId/website/url-redirects/flower-shop-network'
)({
  component: WebsiteRedirectFsnPage,
  loader: flowerShopNetworkRedirectsLoader,
})
